import { jsx as _jsx } from "react/jsx-runtime";
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { StyledLayoutBase, layoutBasePropsToStyledProps } from './LayoutBase';
export const Box = ({ children, testId, ...layoutBaseProps }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    return (_jsx(StyledLayoutBase, { ...layoutBasePropsToStyledProps(layoutBaseProps), ...testIdAttribute, children: children }));
};
